export enum DamageInternalState {
  EingegangenOhneKV = 0,
  EingegangenMitKV = 1,
  Abgelehnt = 2,
  Angenommen = 3,
  VersicherungGemeldet = 4,
  ExperteAufgeboten = 5,
  VersicherungFreigegeben = 6,
  RechnungEingegangen = 7,
  VersicherungRueckerstattet = 8,
  Abgeschlossen = 9
}

export const DamageInternalStateLabels: Record<DamageInternalState, string> = {
  [DamageInternalState.EingegangenOhneKV]: 'Eingegangen ohne KV',
  [DamageInternalState.EingegangenMitKV]: 'Eingegangen mit KV',
  [DamageInternalState.Abgelehnt]: 'Abgelehnt',
  [DamageInternalState.Angenommen]: 'Angenommen',
  [DamageInternalState.VersicherungGemeldet]: 'Versicherung gemeldet',
  [DamageInternalState.ExperteAufgeboten]: 'Experte aufgeboten',
  [DamageInternalState.VersicherungFreigegeben]: 'Versicherung freigegeben',
  [DamageInternalState.RechnungEingegangen]: 'Rechnung eingegangen',
  [DamageInternalState.VersicherungRueckerstattet]: 'Versicherung rückerstattet',
  [DamageInternalState.Abgeschlossen]: 'Abgeschlossen'
};

export enum DamageDocumentType {
  Kostenvoranschlag = 0,
  Versicherungsdokument = 1,
  Rechnung = 2,
  Sonstiges = 3
}

export const DamageDocumentTypeLabels: Record<DamageDocumentType, string> = {
  [DamageDocumentType.Kostenvoranschlag]: 'Kostenvoranschlag',
  [DamageDocumentType.Versicherungsdokument]: 'Versicherungsdokument',
  [DamageDocumentType.Rechnung]: 'Rechnung',
  [DamageDocumentType.Sonstiges]: 'Sonstiges'
};